import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LabelStyle = styled(Typography)(({ theme, ...props }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
  ...props
}));

export default LabelStyle;
